// Shopify theme asset. Uses Shopify privacy permissions and no browser storage.
(() => {
  const id=new URL(location.href).searchParams.get('dd_eid')
  const valid=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id || '')
  let saved=false,busy=false
  const capture=async(event)=>{
    const privacy=window.Shopify?.customerPrivacy
    if(!privacy || busy)return
    const allowed=privacy.analyticsProcessingAllowed() && privacy.marketingAllowed()
    if(allowed && (!valid || saved))return
    if(!allowed && !saved && event?.type!=='visitorConsentCollected')return
    busy=true
    try {
      const response=await fetch(`${window.Shopify.routes?.root || '/'}cart/update.js`,{
        method:'POST',headers:{'Content-Type':'application/json'},signal:AbortSignal.timeout(5000),
        body:JSON.stringify({attributes:{dd_eid:allowed?id.toLowerCase():''}})
      })
      saved=allowed && response.ok
    } catch {} finally{
      busy=false
      if(Boolean(privacy.analyticsProcessingAllowed() && privacy.marketingAllowed())!==allowed)
        capture({type:'visitorConsentCollected'})
    }
  }
  document.addEventListener('visitorConsentCollected',capture)
  if(window.Shopify?.customerPrivacy)capture()
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)capture()})
})()
